import { TaskFieldView, TaskFieldViewProps } from '../TaskFieldView';

interface Props extends TaskFieldViewProps {
    canEdit: boolean;
    children: React.ReactElement<any>;
}

export function TaskInputSubstitutor({ canEdit, children, ...viewProps }: Props): React.ReactElement<any> {
    return canEdit ? children : <TaskFieldView {...viewProps} />;
}
